import React from 'react'
import { PurchaseContext } from '../contexts/PurchaseContext'
import RecommendCarousel from './RecommendCarousel'
import CollectionSelect from './CollectionSelect';
import ProductSelect from './ProductSelect';
import SpinnerOverlay from '../../common/components/SpinnerOverlay'

import families from '../data/productFamilies';
import { type ProductDefaults } from '../../common/types/webshop.types';

declare function showCart(...args: any[]): void;

type Props = {
    onAddToCart? : Function,
    isLegacy: boolean
}

export default function PurchaseWindowFull({onAddToCart = showCart, isLegacy} : Props) {
    const [state, setState] = React.useContext(PurchaseContext);

    const handleCarouselClick = (event : React.MouseEvent<HTMLDivElement>) => {
        const data = event.currentTarget.dataset;
        const familyName = data.product;
        const newState = {...state, family : familyName}
        const family = findFamilyByName(familyName);
        if(!family) return;
        const newDefaults : ProductDefaults = {subfamily: data.subproduct, host: null, type: null};
        newDefaults.host = family.defaults.host;
        newDefaults.type = family.defaults.type;
        
        newState.defaults = newDefaults;

        setState(newState);
    }

    return (
        <div className="container">
            <div className='row' id="purchase-window">
                <div className="col-md-2 col-12">
                    <CollectionSelect isLegacy={isLegacy} />
                </div>
                <div className="col-md-10 col-12">
                    <SpinnerOverlay hidden={!state.loading} message='Loading'>
                    <div className="row" style={{minHeight: '450px'}}>
                        <div className='col-7'>
                            <img src={state.bannerUrl} className='horizontal-logo' />
                            <div dangerouslySetInnerHTML={state.productHtml} />
                        </div>
                        <div className='col-5'>
                            <ProductSelect onAddToCart={onAddToCart} />
                        </div>
                    </div>
                    </SpinnerOverlay>
                    <hr />
                    <div className="row">
                        <div className="col-12">
                            <RecommendCarousel onClick={handleCarouselClick} />
                        </div>
                    </div>
                    <hr />
                </div>
            </div>
        </div>
    )
}

const findFamilyByName = (name : string) => {
    const slug = slugify(name);
    const family = families.find(item => {
        return slug == item.slug;
    });
    return family;
}

const slugify = (text : string) => {
    return text.toString().toLowerCase()
	.replace(/\s+/g, '-')           // Replace spaces with -
	.replace(/[^\w\-]+/g, '')       // Remove all non-word chars
	.replace(/\-\-+/g, '-')         // Replace multiple - with single -
	.replace(/^-+/, '')             // Trim - from start of text
	.replace(/-+$/, '');            // Trim - from end of text
}